export default "__VITE_ASSET__a8d6115d__"